import { memo } from 'react';
import { arrayOf, node, oneOfType, string } from 'prop-types';
import classnames from 'classnames';
import {
  PrimaryButton,
  SecondaryButton,
  UnderlinedButton,
} from 'jl-design-system/elements/button/Button';
import { DefaultButton } from './default-button';
import { NativeButton } from './native-button';
import { DisabledButton } from './disabled-button';

import styles from './Button.scss';

export const Button = memo(({ view = 'native', children, className, ...props }) => {
  const buttons = {
    // eslint-disable-next-line react/display-name,react/prop-types
    primary: ({ className: primaryBtnClassName, ...primaryBtnProps }) => (
      <PrimaryButton
        className={classnames(styles.PrimaryButton, primaryBtnClassName)}
        {...primaryBtnProps}
      />
    ),
    secondary: SecondaryButton,
    underlined: UnderlinedButton,
    default: DefaultButton,
    native: NativeButton,
    disabled: DisabledButton,
  };

  const ButtonComponent = buttons[view];

  return (
    <ButtonComponent className={classnames(styles.Button, className)} {...props}>
      {children}
    </ButtonComponent>
  );
});

Button.displayName = 'Button';

Button.propTypes = {
  view: string,
  children: oneOfType([node, arrayOf(node)]).isRequired,
  className: string,
};
